// extracted by mini-css-extract-plugin
export var cartIcon = "_oz-0";
export var cartIconContainer = "_oz-1";